import { render } from "./Growth.vue?vue&type=template&id=6a64ec55&scoped=true&ts=true"
import script from "./Growth.vue?vue&type=script&lang=ts"
export * from "./Growth.vue?vue&type=script&lang=ts"

import "./Growth.vue?vue&type=style&index=0&id=6a64ec55&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a64ec55"]])

export default __exports__